import Vue from 'vue'

const state = {
    path: [],
    tree: [],
    loading: false
}

const getters = {
    getTree: state => {
        return state.tree
    },
    getTreePath: state => {
        return state.path;
    },
    getTreeLoading: state => {
        return state.loading;
    }
}

const mutations = {
    InsertLevel (state, params) {
        Vue.set(state.tree, params.levelIndex + 1, params.level);
        return state;
    },

    SetPath (state, params) {
        Vue.set(state.path, params.levelIndex + 1, { login: params.login, index: params.index });
        return state;
    },

    BackToLevel (state, params) {
        state.tree.splice(params.levelIndex, state.tree.length - params.levelIndex);
        state.path.splice(params.levelIndex, state.tree.length - params.levelIndex + 1);
        return state;
    },

    BackToLevelWithoutPath (state, params) {
        state.tree.splice(params.levelIndex, state.tree.length - params.levelIndex);
        state.path.splice(params.levelIndex, state.tree.length - params.levelIndex + 2);
        return state;
    },

    ShowTreeLoader (state, params) {
        state.loading = params.loading;
        return state;
    },

    ClearTree (state) {
        state.tree = [];
        state.path = [];
        return state;
    }
}

export default {
    state,
    getters,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tree.js